import { images } from '../constants';

const services = [
  {
    id: 1,
    image: images.service1,
    title: 'HTML Templates',
    link: '/Website-Templates',
    content: 'Modern and responsive HTML templates for fast website launches.',
    paragraphs: [
      'Our HTML templates are designed with clean code and modern UI to help you build websites quickly without starting from scratch.',
      'Perfect for startups, businesses, and developers looking for ready-to-use layouts.'
    ], 
    features: [
      'Fully Responsive Design',
      'Clean & Well-Structured Code',
      'Cross-Browser Compatible',
      'Easy Customization',
      'Fast Loading Speed'
    ]
  },
  {
    id: 2,
    image: images.service2,
    title: 'React Templates',
    link: '/Website-Templates',
    content: 'Dynamic and reusable React templates for modern web apps.',
    paragraphs: [
      'Built with React, our templates offer component-based architecture for scalable and efficient development.',
      'Ideal for SaaS, startups, and modern web applications.'
    ],
    features: [
      'Reusable Components',
      'Modern UI/UX Design',
      'Fast Performance',
      'Easy Integration',
      'Developer-Friendly Structure'
    ]
  },
  {
    id: 3,
    image: images.service3,
    title: 'Landing Pages',
    link: '/Website-Templates',
    content: 'High-converting landing page templates for all niches.',
    paragraphs: [
      'Create stunning landing pages designed to convert visitors into customers.',
      'Perfect for marketing campaigns, product launches, and startups.'
    ],
    features: [
      'Conversion-Focused Design',
      'Mobile Optimized',
      'SEO Friendly',
      'Fast Loading',
      'Easy Customization'
    ]
  },
  {
    id: 4,
    image: images.service4,
    title: 'Portfolio Templates',
    link: '/Website-Templates',
    content: 'Creative portfolio templates for professionals.',
    paragraphs: [
      'Showcase your work with stylish and modern portfolio designs.',
      'Ideal for developers, designers, and freelancers.'
    ],
    features: [
      'Clean Layouts',
      'Modern Design',
      'Responsive UI',
      'Easy Editing',
      'Professional Look'
    ]
  },
  {
    id: 5,
    image: images.service5,
    title: 'Business Templates',
    link: '/Website-Templates',
    content: 'Professional templates for companies and agencies.',
    paragraphs: [
      'Launch your business website with high-quality templates built for credibility and performance.',
      'Perfect for startups, agencies, and service providers.'
    ],
    features: [
      'Professional Design',
      'Service Pages Included',
      'Contact Forms',
      'SEO Optimized',
      'Fully Responsive'
    ]
  },
  {
    id: 6,
    image: images.service6,
    title: 'Ongoing Support',
    link: '/Contact-us',
    content: 'Support to help you get started and fix minor issues. No extensive customization or third-party integrations.',
    paragraphs: [
      'We provide support to help you set up and customize your templates بسهولة.',
      'Get assistance whenever you need help with your template.'
    ],
    features: [
      'Email Support',
      'Setup Guidance',
      'Documentation Included',
      'Quick Responses',
      'Beginner Friendly'
    ]
  }
];

export default services;